import { State } from "./types";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { getZoneState } from "./utils";

function handleRequest(
  state: State,
  data: Boundaries["retrieveZoneProjects"]["request"],
): State {
  const { index, result } = getZoneState(state, data);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...result, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { ...result, request: setRequestStateToPending() }];
}

export { handleRequest };
